import React, { useContext } from 'react';

import { useMindmap } from '../../pages/mindmap/use-mindmap';
import { MapContextMenuContext } from '../ui/map-context-menu';
import { PanelMenu, PanelMenuValue } from '../ui/panel-menu';

export const NodeContextMenu = () => {
  const {
    copyCutPaste: {
      actions: {
        copySelectable,
        cutSelectable,
        onCopyClick,
        onCutClick,
        onPasteClick,
        onUncutClick,
        pasteSelectable,
        uncutSelectable,
      },
    },
    manipulation: {
      actions: {
        onDeleteClick,
        onAddChildClick,
        onAddTopSiblingClick,
        onAddBottomSiblingClick,
        addBottomSiblingSelectable,
        addTopSiblingSelectable,
        addChildSelectable,
        deleteSelectable,
        addAttachementSelectable,
        onAddFileAttachementClick,
        onAddLinkAttachementClick,
      },
    },
    contextMenu: { setActiveMenu },
  } = useMindmap();

  const panelMenu: PanelMenuValue = [
    {
      label: 'Anhänge',
      icon: 'pi pi-fw pi pi-link',
      children: [
        {
          label: 'Link',
          onClick: () => {
            setActiveMenu({
              type: 'add-link-attachement',
              onCreateClick: (attachement) => {
                onAddLinkAttachementClick(attachement);
                setActiveMenu(undefined);
              },
            });
          },
          icon: 'pi pi-external-link',
          disabled: addAttachementSelectable,
        },
        {
          label: 'File / Image',
          onClick: () => {
            setActiveMenu({
              type: 'add-file-attachement',
              onCreateClick: (attachement) => {
                onAddFileAttachementClick(attachement);
                setActiveMenu(undefined);
              },
            });
          },
          icon: 'pi pi-file',
          disabled: addAttachementSelectable,
        },
      ],
    },
    {
      separator: true,
    },
    {
      label: 'Styling',
      icon: 'pi pi-fw ri-palette-line',
      children: [
        {
          label: 'WIP',
          icon: 'pi ri-brush-3-fill',
          disabled: true,
        },
      ],
    },
    {
      separator: true,
    },
    {
      label: 'Knoten',
      icon: 'pi ri-mind-map',
      children: [
        {
          label: 'Nachbarsknoten',
          icon: 'pi pi-angle-up',
          onClick: onAddTopSiblingClick,
          disabled: addTopSiblingSelectable,
        },
        {
          label: 'Nachbarsknoten',
          icon: 'pi pi-angle-down',
          onClick: onAddBottomSiblingClick,
          disabled: addBottomSiblingSelectable,
        },
        {
          label: 'Unterknoten',
          icon: 'pi pi-angle-right',
          onClick: onAddChildClick,
          disabled: addChildSelectable,
        },
        {
          label: 'Knoten löschen',
          icon: 'pi pi-trash',
          onClick: onDeleteClick,
          disabled: deleteSelectable,
        },
      ],
    },
    {
      separator: true,
    },
    {
      label: 'Copy & Paste',
      icon: 'pi pi-fw pi-pencil',
      children: [
        {
          label: 'Copy',
          onClick: onCopyClick,
          icon: 'pi ri-clipboard-line',
          disabled: !copySelectable,
        },
        {
          label: 'Cut',
          onClick: onCutClick,
          icon: 'pi ri-scissors-cut-line',
          disabled: !cutSelectable,
        },
        {
          label: 'Paste',
          onClick: onPasteClick,
          icon: 'pi ri-file-copy-line',
          disabled: !pasteSelectable,
        },
        {
          label: 'Uncut',
          onClick: onUncutClick,
          icon: 'pi ri-arrow-go-back-line',
          disabled: !uncutSelectable,
        },
      ],
    },
  ];

  const { onShrinkingAnimationStart, onGrowingAnimationStart } = useContext(MapContextMenuContext);

  return (
    <PanelMenu
      value={panelMenu}
      onExitAnimationStart={onShrinkingAnimationStart}
      onEnterAnimationStart={onGrowingAnimationStart}
    />
  );
};
